export const TIER_REFERRAL_REQUIREMENTS = {
  SILVER: 5,
  GOLD: 15,
  BLACK: 25,
};
export const TIER_REFERRAL_REWARDS = {
  BRONZE: 2,
  SILVER: 3,
  GOLD: 4,
  BLACK: 5,
};

const useRafCalculations = (tier: string, referredAmount: number) => {
  let textBlockHeader = "";
  let referredInfoText = "";

  const tiersWithThresholds = [
    { name: "Black", threshold: TIER_REFERRAL_REQUIREMENTS.BLACK },
    { name: "Gold", threshold: TIER_REFERRAL_REQUIREMENTS.GOLD },
    { name: "Silver", threshold: TIER_REFERRAL_REQUIREMENTS.SILVER },
  ];

  const getNextTier = (referredAmount: number) => {
    const tier = tiersWithThresholds.find(({ threshold }) => referredAmount >= threshold);
    return tier ? tier.name : "Silver"; // Default to "silver" if no threshold is met
  };

  const getReferralMessage = (
    referredAmount: number,
    requiredForNextTier: number,
    nextTier: string,
  ) => {
    if (referredAmount >= requiredForNextTier) {
      const nextTier = getNextTier(referredAmount);
      return `Congratulations on referring ${referredAmount} trading clients! Your promotion to ${nextTier} will take effect at the start of next month.`;
    } else {
      return `Refer ${
        requiredForNextTier - referredAmount
      } more trading clients to upgrade to ${nextTier}`;
    }
  };

  switch (tier) {
    case "bronze":
      textBlockHeader = `Receive ${TIER_REFERRAL_REWARDS.BRONZE}% of`;
      referredInfoText = getReferralMessage(
        referredAmount,
        TIER_REFERRAL_REQUIREMENTS.SILVER,
        "Silver",
      );
      break;

    case "silver":
      textBlockHeader = `Receive ${TIER_REFERRAL_REWARDS.SILVER}% of`;
      referredInfoText = getReferralMessage(
        referredAmount,
        TIER_REFERRAL_REQUIREMENTS.GOLD,
        "Gold",
      );
      break;

    case "gold":
      textBlockHeader = `Receive ${TIER_REFERRAL_REWARDS.GOLD}% of`;
      referredInfoText = getReferralMessage(
        referredAmount,
        TIER_REFERRAL_REQUIREMENTS.BLACK,
        "Black",
      );
      break;

    case "black":
      textBlockHeader = `Receive ${TIER_REFERRAL_REWARDS.BLACK}% of`;
      referredInfoText = `Congrats! You've reached our highest tier.`;
      break;

    default:
      textBlockHeader = `Receive ${TIER_REFERRAL_REWARDS.BRONZE}% of`;
      referredInfoText = `Refer ${
        TIER_REFERRAL_REQUIREMENTS.SILVER - referredAmount
      } more trading clients to upgrade to Silver.`;
      break;
  }

  return { textBlockHeader, referredInfoText };
};

export default useRafCalculations;
